import {delayHit, hitAlgolytics} from "@pg-mono/algolytics";

import {getAnalyticsSortDescription} from "../../offer/list/helpers/handle_fetch_offer_list_gtm_events";
import {getTrackedSiteData} from "./tracked_utils/tracked_site";

export const pageViewAlgolytics = delayHit((payload: Object) => hitAlgolytics("search", payload), 500);

export const forInvestmentOfferListSearchHit = (
    category: string | null,
    subcategory: string | null,
    sort: string,
    offersData: {offer_id: number[]; offer_name: string[]; vendor_id: number[]; vendor_name: string[]}
) => {
    const search_sort = getAnalyticsSortDescription(sort);
    const payload = {
        view_type: "for_investment_offer_list",
        category,
        subcategory,
        ...offersData,
        ...getTrackedSiteData(),
        ...(search_sort ? {search_sort} : {})
    };
    pageViewAlgolytics(payload);
};
import {delayHit, hitAlgolytics} from "@pg-mono/algolytics";

import {getAnalyticsSortDescription} from "../../offer/list/helpers/handle_fetch_offer_list_gtm_events";
import {getTrackedSiteData} from "./tracked_utils/tracked_site";

export const pageViewAlgolytics = delayHit((payload: Object) => hitAlgolytics("search", payload), 500);

export const forInvestmentOfferListSearchHit = (
    category: string | null,
    subcategory: string | null,
    sort: string,
    offersData: {offer_id: number[]; offer_name: string[]; vendor_id: number[]; vendor_name: string[]}
) => {
    const search_sort = getAnalyticsSortDescription(sort);
    const payload = {
        view_type: "for_investment_offer_list",
        category,
        subcategory,
        ...offersData,
        ...getTrackedSiteData(),
        ...(search_sort ? {search_sort} : {})
    };
    pageViewAlgolytics(payload);
};
